<div class="special-content">
  <div class="downloadSection">
    <section class="hero-section" [style.backgroundImage]="'url(' + bgdownloadImageUrl + ')'">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-7 offset-md-5">
            <div class="overlay-box text-white">
              <h3 class="mobileapp">{{ 'Download the Visit Seychelles Mobile App Now!' | translate }}</h3>
              <div class="app-buttons mt-3">
                <a href="https://play.google.com/store/apps/details?id=com.seychelles.android" target="_blank">
                  <img
                    [src]="playstoreImageUrl"
                    class="box-img img6"
                    style="cursor: pointer; max-width: 240px"
                    alt="download The Seychelles Islands from playstore"
                  />
                </a>
                <a
                  style="margin-top: 10px"
                  href="https://apps.apple.com/sc/app/visit-seychelles/id1663916867"
                  target="_blank"
                >
                  <img
                    [src]="iosImageUrl"
                    class="box-img img6"
                    style="cursor: pointer; max-width: 240px"
                    alt="download The Seychelles Islands from App Store"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <img src="../../../assets/images/mobile.avif" alt="Phone Image" class="phone-img" />
    </section>
  </div>
</div>
